import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";
import type { StringifiableRecord } from "query-string";

import { landingPageSetupLink } from "../core/apiLink";

export namespace ApiLandingPageInfo {
  export interface IGetSetupResponse {
    ifSetup: boolean;
    setupTime: string;
  }

  type IGetSetupInfoResponse = {
    data: IGetSetupResponse;
    success: boolean;
  };

  export interface IPostSetupInfoResponse {
    success: boolean;
    message?: string;
  }

  export const getSetupInfo = (params: StringifiableRecord) =>
    baseFetch<StringifiableRecord, IGetSetupInfoResponse>({
      method: "GET",
      url: landingPageSetupLink,
      useSessionAccountId: true,
      params,
    });

  export const landingPageSetup = (params: StringifiableRecord) => {
    return baseFetch<StringifiableRecord, IPostSetupInfoResponse>({
      method: "POST",
      url: getUrlWithSearchParams(landingPageSetupLink, params),
      useSessionAccountId: true,
      params,
    });
  };
}
